import { Helmet } from "react-helmet-async";
import LandingItalyBanner from "../landingPages/landingItaly/LandingItalyBanner";
import LandingItalyLaunch from "../landingPages/landingItaly/LandingItalyLaunch";
import LandingItalyWorks from "../landingPages/landingItaly/LandingItalyWorks";
import LandingItalyChoose from "../landingPages/landingItaly/LandingItalyChoose";
import LandingItalyApps from "../landingPages/landingItaly/LandingItalyApps";
import LandingItalyGet from "../landingPages/landingItaly/LandingItalyGet";
import LandingItalyMarket from "../landingPages/landingItaly/LandingItalyMarket";
import LandingItalyGo from "../landingPages/landingItaly/LandingItalyGo";
import ShuttleAppreciation from "../shuttle_software/ShuttleAppreciation";
import TaxiFaq from "../taxiDispatchSoftware/TaxiFaq";
import OnDemandWork from "../cloneApps/onDemand/OnDemandWork";

const BannerData = {
  title: "The Best Limo Booking Software to Power Your Fleet",
  desc: "Empower your brand with our premium chauffeur dispatch system. Designed for precision, elegance, and effortless management of global limousine operations.",
  demo: "21 Days Free Trial | No Credit Card Required",
  cta1: "book free demo",
  cta2: "Explore Features",
  slideText: "Trusted by 1,000+ Companies Worldwide"
}

const goData = {
  title: "Why Pick Limo Booking Software?",
  subTitle: "Streamline Your Premium Operations with Digital Precision",
  desc: "Investing in the best Limo booking software is no longer optional for growth; it is the engine that drives efficiency. Our limo booking solutions eliminate manual scheduling errors, allowing you to scale your fleet while maintaining the high-touch service your elite clients expect. By integrating a dedicated chauffeur booking system, you provide a seamless, modern interface that matches the luxury of your vehicles.",
  cta: "get started",
  cta2: "Schedule a free Demo",
  cta3: "Explore More",
  boxes: [
    {
      title: "Multi-Currency & Language",
      desc: "Expand your reach globally with a limousine reservation software that supports international clientele.",
      image: "/assets/home/land2-rider-1.webp",
    },
    {
      title: "Real-Time Global Tracking",
      desc: "Gain 100% visibility over your fleet with high-precision GPS integrated into our limo dispatch software.",
      image: "/assets/home/land2-rider-2.webp",
    },
    {
      title: "Advanced Flight Tracking",
      desc: "Automatically adjust pickup times based on real-time flight data to ensure chauffeurs are always on time.",
      image: "/assets/home/land2-rider-3.webp",
    },
    {
      title: "Automated Billing & Invoicing",
      desc: "Generate professional digital receipts and manage corporate accounts effortlessly through the limousine booking software.",
      image: "/assets/home/land2-rider-4.webp",
    },
    {
      title: "Dynamic Pricing Engine",
      desc: "Set custom rates for airport transfers, hourly bookings, or point-to-point travel with our limo reservation software.",
      image: "/assets/home/land2-rider-5.webp",
    },
    {
      title: "White-Label Customization",
      desc: "Every touchpoint of the chauffeur booking software reflects your brand’s unique identity and luxury aesthetic.",
      image: "/assets/home/land2-rider-6.webp",
    },
  ]
}

const marketData = {
  titlePart1: "Ready to Modernize ",
  titlePart2: "Your Chauffeur Business?",
  desc: "Contact Mobility Infotech today to see how our best Limo booking software can transform your daily operations and increase your booking volume.",
  cta: "Get in touch",
}

const getData = {
  title: 'What You Get',
  // subTitle: "Everything You Need to Manage Your Bus Fleet Efficiently",
  desc: "Our comprehensive limo booking solutions package provides a full-stack ecosystem. You receive a synchronized suite of applications designed to connect passengers, drivers, and dispatchers in one seamless loop."
}

const appData = {
  title: "Passenger App",
  desc: "Provide your clients with a premium booking experience that mirrors the luxury of their ride. Our limo reservation software app allows for instant bookings, vehicle selection, and transparent pricing.",
  cta: "Schedule a free Demo",
  boxes: [
    {
      title: "Instant Reservations",
      desc: "Secure a luxury ride in seconds with a user-friendly interface.",
      image: "/assets/home/land2-app-logo-1.webp",
    },
    {
      title: "Multiple Payment Options",
      desc: "Support for credit cards, digital wallets, and corporate billing.",
      image: "/assets/home/land2-app-logo-2.webp",
    },
    {
      title: "Real-Time ETA",
      desc: "Passengers can track their assigned chauffeur’s location in real-time.",
      image: "/assets/home/land2-app-logo-3.webp",
    },
    {
      title: "Ride History",
      desc: "Easy access to past trips and downloadable invoices for expense reporting.",
      image: "/assets/home/land2-app-logo-4.webp",
    },
  ]
}

const appData1 = {
  title: "Driver App",
  desc: "Empower your chauffeurs with a dedicated chauffeur booking system that simplifies trip management. This intuitive app ensures drivers stay focused on the road while receiving all necessary trip details.",
  boxes: [
    {
      title: "Smart Trip Alerts",
      desc: "Instant notifications for new bookings and schedule changes.",
      image: "/assets/home/land2-app-logo-1.webp",
    },
    {
      title: "Navigation Integration",
      desc: "Built-in maps with optimized routing to avoid heavy traffic.",
      image: "/assets/home/land2-app-logo-2.webp",
    },
    {
      title: "Earnings Dashboard",
      desc: "Transparent daily and weekly revenue tracking for every driver.",
      image: "/assets/home/land2-app-logo-3.webp",
    },
    {
      title: "Digital Logs",
      desc: "Automated duty status and trip duration tracking for compliance.",
      image: "/assets/home/land2-app-logo-4.webp",
    },
  ]
}

const appData2 = {
  title: "Admin Dashboard",
  desc: "The command center of the best Limo booking software, giving you total control over your business. Manage your fleet, analyze performance, and optimize your revenue from a single screen.",
  boxes: [
    {
      title: "Comprehensive Analytics",
      desc: "Data-driven insights into peak booking hours and fleet performance.",
      image: "/assets/home/land2-app-logo-5.webp",
    },
    {
      title: "Driver Management",
      desc: "Easily onboard, verify, and monitor your team of professional chauffeurs.",
      image: "/assets/home/land2-app-logo-6.webp",
    },
    {
      title: "Custom Rate Management",
      desc: "Flexibility to set surge pricing or special corporate discounts.",
      image: "/assets/home/land2-app-logo-7.webp",
    },
    {
      title: "System Configuration",
      desc: "Control every aspect of your limousine booking software settings.",
      image: "/assets/home/land2-app-logo-8.webp",
    },
  ]
}

const appData3 = {
  title: "Dispatcher Panel",
  desc: "Our Best Limo Dispatch Software features a high-speed dispatcher panel designed for rapid response. Manage immediate requests and future bookings with a drag-and-drop interface.",
  boxes: [
    {
      title: "Auto-Dispatch Logic",
      desc: "Intelligently assign the nearest driver to reduce wait times.",
      image: "/assets/home/land2-app-logo-9.webp",
    },
    {
      title: "Manual Override",
      desc: "Total control for dispatchers to prioritize VIP clients and specific requests.",
      image: "/assets/home/land2-app-logo-10.webp",
    },
    {
      title: "Interactive Map",
      desc: "A live bird’s-eye view of all active, idle, and en-route vehicles.",
      image: "/assets/home/land2-app-logo-3.webp",
    },
    {
      title: "Communication Hub",
      desc: "Direct messaging between dispatchers, drivers, and passengers.",
      image: "/assets/home/land2-app-logo-11.webp",
    },
  ]
}

const chooseData = {
  titlePart1: "Why Choose ",
  titlePart2: "Mobility Infotech?",
  subTitle: "Because we genuinely care about your limo booking solutions.",
  desc: "Our team prioritizes your success by offering more than just software. Our deep mobility expertise promises tailored limousine booking software that drives growth.",
  ctaTitle: "Mobility Infotech: A Smarter Way to Manage Your Bus Transportation Network",
  cta1: "Schedule a free Demo",
  cta2: "Explore More",
  boxes: [
    {
      title: "Scalable Architecture",
      desc: "Built to support growing fleets from 5 to 5,000 vehicles.",
      image: "/assets/home/land2-choose-icon-1.webp",
    },
    {
      title: "24/7 Technical Support",
      desc: "Our experts ensure your chauffeur dispatch system never goes offline.",
      image: "/assets/home/land2-choose-icon-2.webp",
    },
    {
      title: "High Security Standards",
      desc: "Enterprise-grade encryption to protect sensitive client data.",
      image: "/assets/home/land2-choose-icon-3.webp",
    },
    {
      title: "Seamless Integrations",
      desc: "Connects easily with existing CRM and accounting tools.",
      image: "/assets/home/land2-choose-icon-4.webp",
    },
    {
      title: "User-Centric Design",
      desc: "Minimal learning curve for both your staff and your customers.",
      image: "/assets/home/land2-choose-icon-5.webp",
    },
    {
      title: "Proven Track Record",
      desc: "Trusted by luxury transport providers worldwide for reliable limo booking solutions.",
      image: "/assets/home/land2-choose-icon-6.webp",
    },
  ]
}

const workData = {
  title: 'How It Works',
  desc: "Our Tailored Development Process",
  boxes: [
    {
      title: "Consultation & Planning",
      desc: "We analyze fleet needs, service zones, vehicle categories, and pricing to design your chauffeur booking system.",
    },
    {
      title: "Development & Setup",
      desc: "We build a white-labeled limo reservation platform with custom UI, flight tracking, secure payments, and smart dispatch.",
    },
    {
      title: "Testing & Deployment",
      desc: "We test across devices and deploy your booking software on iOS, Android, and Web with ongoing support.",
    },
  ]

}

const launchData = {
  title: "Experience the Future of Luxury Transport",
  desc: "Get a personalized demo of the best Limo booking software today and see how Mobility Infotech can accelerate your growth.",
  cta1: "Schedule a Free Demo",
  cta2: "Explore Features",
}

const faqData = [
  {
    id: "0",
    question: "01. What makes this the best Limo booking software?",
    answer: "Unlike generic ride-sharing apps, Mobility Infotech combines high-end UI/UX with deep customization specifically for luxury fleets. We provide a scalable ecosystem that manages high-profile client expectations, complex hourly bookings, and professional chauffeur workflows in one unified platform.",
  },
  {
    id: "1",
    question: "02. Can I use my own branding?",
    answer: "Yes, our limo booking solutions are fully white-labeled, meaning your brand remains front and center. From the app icon on the App Store to the digital invoices sent to clients, every touchpoint is customized with your logo, brand colors, and unique service personality.",
  },
  {
    id: "2",
    question: "03. Does the limo dispatch software support airport transfers?",
    answer: "Absolutely. Our limo dispatch software includes specialized flight-tracking features that monitor arrivals in real-time. If a flight is delayed or arrives early, the system automatically updates the chauffeur’s schedule to ensure a seamless, wait-free pickup experience for the passenger.",
  },
  {
    id: "3",
    question: "04. How secure is the chauffeur booking system?",
    answer: "Security is our top priority. We use enterprise-grade, bank-level encryption for all payment transactions and data storage. Our chauffeur booking system is fully GDPR and PCI-compliant, ensuring that your high-net-worth clients’ personal and financial information is always protected.",
  },
  {
    id: "4",
    question: "05. Is the limousine booking software mobile-friendly?",
    answer: 'Yes, our limousine booking software is natively optimized for all iOS and Android devices, as well as mobile browsers. We focus on a "mobile-first" philosophy to ensure that clients can book a premium ride on the go with zero lag and an intuitive interface.',
  },
  {
    id: "5",
    question: "06. Can I manage corporate accounts?",
    answer: "Our limousine reservation software includes a dedicated corporate portal where businesses can manage their own employees' travel. This allows for centralized billing, department-wise ride limits, and automated monthly reporting, making it the best Limo booking software for B2B contracts.",
  },
  {
    id: "6",
    question: "07. Does it support multiple vehicle types?",
    answer: "Yes, the system is highly flexible. You can easily categorize and set unique pricing for everything from executive sedans and SUVs to luxury stretches and party buses. Each vehicle type can have its own specific capacity limits and amenity descriptions within the limo reservation software.",
  },
  {
    id: "7",
    question: "08. How long does setup take?",
    answer: "We pride ourselves on a streamlined deployment process to get your chauffeur booking software live quickly. Depending on the level of custom branding and third-party integrations required, we can typically move from the initial consultation to a fully functional launch within a few weeks.",
  },
  {
    id: "8",
    question: "09. Is there a demo available?",
    answer: "Yes, we encourage potential partners to see the technology in action. You can contact Mobility Infotech today to schedule a comprehensive walkthrough of our limo dispatch software, where our experts will show you how to optimize the platform for your specific business model.",
  },
];


export default function Limo() {
  return (
    <>
      <LandingItalyBanner data={BannerData} />
      <LandingItalyGo data={goData} />
      <LandingItalyMarket data={marketData} />
      <LandingItalyGet data={getData} />
      <LandingItalyApps data={appData} data1={appData1} data2={appData2} data3={appData3} />
      <LandingItalyChoose data={chooseData} />
      <LandingItalyWorks data={workData} />
      <div className="solution-case">
        <OnDemandWork filterData={"Taxi app"} />
      </div>
      <section className="land2-testimonial"><ShuttleAppreciation /></section>
      <section className="land2-faq"><TaxiFaq faqData={faqData} /></section>
      <LandingItalyLaunch data={launchData} />
    </>
  )
}
